// extracted by mini-css-extract-plugin
export default {"title":"style_title__RqpEY","rating_container":"style_rating_container__hDMQ3","rating":"style_rating__OClO4","overview":"style_overview__pDrZT"};